(function() {

  'use strict';

  const CONFIG = {
    maxLength: 12,
    allowedPattern: /^[a-zA-Z0-9\s!@#$%^&*()_\-.,'"]*$/,
    engravingPrice: 0
  };

  const SLOT_COUNT = 3;

  let currentVariantId = null;
  let selectedPersonalizationTexts = [];
  let isPersonalizationEnabled = false;

  const elements = {
    overlay: null,
    modal: null,
    openBtn: null,
    closeBtn: null,
    skipBtn: null,
    confirmBtn: null,
    previewBtn: null,
    productImage: null,
    errorMessage: null,
    hiddenTextInput: null,
    previewOverlay: null,
    previewImage: null,
    closePreview: null
  };

  function getVariantData() {
    if (!currentVariantId || !window.personalizationData) return null;
    return window.personalizationData[currentVariantId] || null;
  }

  function getActiveSlotCount() {
    const variantData = getVariantData();
    if (variantData && variantData.slots && variantData.slots.length) {
      return variantData.slots.length;
    }
    return 1;
  }

  function getSlotData(slotIndex) {
    const variantData = getVariantData();
    if (variantData && variantData.slots && variantData.slots[slotIndex]) {
      return variantData.slots[slotIndex];
    }
    if (slotIndex === 0 && variantData) {
      return {
        label: 'Product 1',
        maxCharacters: variantData.maxCharacters || CONFIG.maxLength,
        textStyle: variantData.textStyle || {}
      };
    }
    return null;
  }

  function getInput(slotNumber) {
    return document.getElementById('personalizationInput' + slotNumber);
  }

  function getOverlay(slotNumber) {
    return document.getElementById('personalizationTextOverlay' + slotNumber);
  }

  function getPreviewText(slotNumber) {
    return document.getElementById('previewText' + slotNumber);
  }

  function getMaxLength(slotNumber) {
    const slotData = getSlotData(slotNumber - 1);
    if (slotData && slotData.maxCharacters && !isNaN(slotData.maxCharacters)) {
      return parseInt(slotData.maxCharacters, 10);
    }
    return CONFIG.maxLength;
  }

  function applyTextStyle(element, textStyle) {
    if (!element || !textStyle) return;

    element.style.position = 'absolute';
    element.style.bottom = textStyle.bottom || '15%';
    element.style.top = textStyle.top || 'auto';
    element.style.left = textStyle.left || '50%';
    element.style.right = textStyle.right || 'auto';
    element.style.transform = textStyle.transform || 'translateX(-50%)';
    element.style.fontSize = textStyle.fontSize || '14px';
    element.style.color = textStyle.color || '#808080';
    element.style.fontWeight = textStyle.fontWeight || '500';
    element.style.letterSpacing = textStyle.letterSpacing || '-0.5px';
    element.style.writingMode = textStyle.writingMode || 'horizontal-tb';
  }

  function applyMaxLength(slotNumber) {
    const input = getInput(slotNumber);
    const max = getMaxLength(slotNumber);

    if (input) {
      input.maxLength = max;
      if (input.value.length > max) {
        input.value = input.value.slice(0, max);
      }
    }

    const charMaxEl = document.getElementById('personalizationCharMax' + slotNumber);
    if (charMaxEl) charMaxEl.textContent = max;

    updateCharCounter(slotNumber);
  }

  function updateCharCounter(slotNumber) {
    const input = getInput(slotNumber);
    const charCountEl = document.getElementById('personalizationCharCount' + slotNumber);
    if (!input || !charCountEl) return;

    const current = input.value.length;
    const max = getMaxLength(slotNumber);
    charCountEl.textContent = current;

    const counterWrapper = charCountEl.closest('.personalization-char-counter');
    if (counterWrapper) {
      counterWrapper.classList.toggle('at-limit', current >= max);
      counterWrapper.classList.toggle('near-limit', current >= Math.max(1, max - 3) && current < max);
    }
  }

  function getAllTexts() {
    const count = getActiveSlotCount();
    const texts = [];

    for (let i = 1; i <= count; i++) {
      const input = getInput(i);
      texts.push(input ? input.value.trim() : '');
    }

    return texts;
  }

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupElements);
    } else {
      setupElements();
    }

    document.addEventListener('shopify:section:load', setupElements);
  }

  function setupElements() {
    elements.overlay = document.getElementById('personalizationModalOverlay');
    elements.modal = document.getElementById('personalizationModal');
    elements.openBtn = document.getElementById('openPersonalizationModal');
    elements.closeBtn = document.getElementById('closePersonalizationModal');
    elements.skipBtn = document.getElementById('skipPersonalization');
    elements.confirmBtn = document.getElementById('confirmPersonalization');
    elements.previewBtn = document.getElementById('previewPersonalization');
    elements.productImage = document.getElementById('personalizationProductImage');
    elements.errorMessage = document.getElementById('personalizationError');
    elements.hiddenTextInput = document.getElementById('personalizationText');
    elements.previewOverlay = document.getElementById('personalizationPreviewOverlay');
    elements.previewImage = document.getElementById('previewImage');
    elements.closePreview = document.getElementById('closePreview');

    if (!elements.overlay) return;

    if (!elements.openBtn) {
      elements.openBtn = document.querySelector('[data-open-personalization-modal]');
    }

    attachEventListeners();
    detectCurrentVariant();
  }

  function attachEventListeners() {
    if (elements.openBtn && !elements.openBtn.dataset.personalizationBound) {
      elements.openBtn.dataset.personalizationBound = 'true';
      elements.openBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openModal();
      });
    }

    if (elements.closeBtn) {
      elements.closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
    }

    if (elements.overlay) {
      elements.overlay.addEventListener('click', function(e) {
        if (e.target === elements.overlay) {
          closeModal();
        }
      });
    }

    if (elements.skipBtn) {
      elements.skipBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        skipPersonalization();
      });
    }

    if (elements.confirmBtn) {
      elements.confirmBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        confirmPersonalization();
      });
    }

    if (elements.previewBtn) {
      elements.previewBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openPreview();
      });
    }

    if (elements.closePreview) {
      elements.closePreview.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closePreview();
      });
    }

    if (elements.previewOverlay) {
      elements.previewOverlay.addEventListener('click', function(e) {
        if (e.target === elements.previewOverlay) {
          closePreview();
        }
      });
    }

    for (let i = 1; i <= SLOT_COUNT; i++) {
      const input = getInput(i);
      if (!input || input.dataset.personalizationBound === 'true') continue;

      input.dataset.personalizationBound = 'true';
      input.addEventListener('input', function(e) {
        handleInput(e, i);
      });

      input.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (elements.confirmBtn && !elements.confirmBtn.disabled) {
            confirmPersonalization();
          }
        }
      });
    }

    document.addEventListener('change', function(e) {
      if (e.target.name === 'id' || e.target.matches('[data-product-variant-id]')) {
        detectCurrentVariant();
      }
    });

    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-product-swatch]')) {
        setTimeout(detectCurrentVariant, 0);
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && elements.overlay && elements.overlay.style.display !== 'none') {
        closeModal();
      }
    });
  }

  function openModal() {
    if (!elements.overlay) return;

    detectCurrentVariant();
    updateModalContent();

    elements.overlay.style.display = 'flex';

    setTimeout(function() {
      elements.overlay.classList.add('active');
    }, 10);

    const firstInput = getInput(1);
    if (firstInput) {
      setTimeout(function() {
        firstInput.focus();
      }, 300);
    }

    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!elements.overlay) return;

    if (typeof window.rabitatResetSafariZoom === 'function') {
      window.rabitatResetSafariZoom();
    }

    elements.overlay.classList.remove('active');

    setTimeout(function() {
      elements.overlay.style.display = 'none';
      document.body.style.overflow = '';
      if (typeof window.rabitatResetSafariZoom === 'function') {
        window.rabitatResetSafariZoom();
      }
    }, 300);
  }

  function skipPersonalization() {
    isPersonalizationEnabled = false;
    selectedPersonalizationTexts = [];

    if (elements.hiddenTextInput) elements.hiddenTextInput.value = '';

    const engravingRequiredEl = document.getElementById('engravingRequired');
    if (engravingRequiredEl) engravingRequiredEl.value = 'false';

    closeModal();
  }

  function confirmPersonalization() {
    const texts = getAllTexts();
    const count = getActiveSlotCount();

    for (let i = 0; i < count; i++) {
      if (!texts[i] || !validateInput(texts[i], i + 1)) {
        showError('Please enter valid personalization text for all products');
        return;
      }
    }

    isPersonalizationEnabled = true;
    selectedPersonalizationTexts = texts;

    if (elements.hiddenTextInput) {
      elements.hiddenTextInput.value = texts.join(' | ');
    }

    const engravingRequiredEl = document.getElementById('engravingRequired');
    if (engravingRequiredEl) engravingRequiredEl.value = 'true';

    generatePreviewImage(texts, function(previewImageUrl) {
      if (previewImageUrl) {
        const variantImageUrlEl = document.getElementById('variantImageUrl');
        if (variantImageUrlEl) variantImageUrlEl.value = previewImageUrl;
      }

      closeModal();

      if (previewImageUrl) {
        addToCart(currentVariantId, true, texts, previewImageUrl);
      } else {
        addToCart(currentVariantId, true, texts, null);
      }
    });
  }

  function handleInput(e, slotNumber) {
    const text = e.target.value;

    updateTextPreview(text, slotNumber);
    updateCharCounter(slotNumber);
    updateConfirmButtonState();

    if (validateInput(text, slotNumber) || text.trim() === '') {
      hideError();
    }
  }

  function updateConfirmButtonState() {
    const count = getActiveSlotCount();
    let allValid = true;

    for (let i = 1; i <= count; i++) {
      const input = getInput(i);
      const text = input ? input.value.trim() : '';
      if (!text || !validateInput(text, i)) {
        allValid = false;
        break;
      }
    }

    if (elements.confirmBtn) {
      elements.confirmBtn.disabled = !allValid;
    }
    if (elements.previewBtn) {
      elements.previewBtn.disabled = !allValid;
    }
  }

  function validateInput(text, slotNumber) {
    const maxLen = getMaxLength(slotNumber);

    if (text.length > maxLen) {
      showError('Maximum ' + maxLen + ' characters allowed');
      return false;
    }

    if (!CONFIG.allowedPattern.test(text)) {
      showError('Invalid characters detected. Only letters, numbers, and select special characters allowed.');
      return false;
    }

    const emojiPattern = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u;
    if (emojiPattern.test(text)) {
      showError('Emojis are not allowed');
      return false;
    }

    return true;
  }

  function showError(message) {
    if (elements.errorMessage) {
      elements.errorMessage.textContent = message;
      elements.errorMessage.style.display = 'block';
    }
  }

  function hideError() {
    if (elements.errorMessage) {
      elements.errorMessage.style.display = 'none';
      elements.errorMessage.textContent = '';
    }
  }

  function updateTextPreview(text, slotNumber) {
    const overlay = getOverlay(slotNumber);
    if (!overlay) return;

    if (text.trim() === '') {
      overlay.textContent = '';
      overlay.style.display = 'none';
      return;
    }

    overlay.textContent = text;
    overlay.style.display = 'block';

    const slotData = getSlotData(slotNumber - 1);
    if (slotData && slotData.textStyle) {
      applyTextStyle(overlay, slotData.textStyle);
    }
  }

  function detectCurrentVariant() {
    const variantInput = document.querySelector('[data-product-variant-id], input[name="id"]');
    if (variantInput && variantInput.value) {
      currentVariantId = variantInput.value;
      return;
    }

    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect && variantSelect.value) {
      currentVariantId = variantSelect.value;
    }
  }

  function updateModalContent() {
    const variantData = getVariantData();
    if (!variantData) return;

    const slotCount = getActiveSlotCount();

    for (let i = 1; i <= SLOT_COUNT; i++) {
      const slotEl = document.querySelector('.personalization-slot[data-slot="' + i + '"]');
      const overlay = getOverlay(i);
      const labelEl = document.getElementById('personalizationLabel' + i);
      const slotData = getSlotData(i - 1);
      const isActive = i <= slotCount;

      if (slotEl) slotEl.style.display = isActive ? 'block' : 'none';
      if (overlay) overlay.style.display = isActive ? '' : 'none';

      if (isActive) {
        applyMaxLength(i);

        if (labelEl && slotData && slotData.label) {
          labelEl.textContent = slotData.label;
        }

        if (overlay && slotData && slotData.textStyle) {
          applyTextStyle(overlay, slotData.textStyle);
        }

        const input = getInput(i);
        if (input && input.value) {
          updateTextPreview(input.value, i);
        }
      }
    }

    const maxCharsTextEl = document.getElementById('personalizationMaxCharsText');
    if (maxCharsTextEl) {
      maxCharsTextEl.textContent = getMaxLength(1);
    }

    if (elements.productImage) {
      if (variantData.image) {
        elements.productImage.src = variantData.image;
        const imageInput = document.getElementById('variantImageUrl');
        if (imageInput) imageInput.value = variantData.image;
      } else {
        const featuredImage = document.querySelector('.rabitat-product-page__hero-image, .product-featured-image img, .product__media img');
        if (featuredImage) {
          elements.productImage.src = featuredImage.src;
        }
      }
    }

    updateConfirmButtonState();
  }

  function openPreview() {
    const texts = getAllTexts();
    const count = getActiveSlotCount();

    for (let i = 0; i < count; i++) {
      if (!texts[i] || !validateInput(texts[i], i + 1)) {
        showError('Please enter valid text to preview');
        return;
      }
    }

    if (!elements.previewOverlay) return;

    if (elements.previewImage && elements.productImage) {
      elements.previewImage.src = elements.productImage.src;
    }

    for (let i = 1; i <= SLOT_COUNT; i++) {
      const previewText = getPreviewText(i);
      const isActive = i <= count;

      if (!previewText) continue;

      if (!isActive) {
        previewText.style.display = 'none';
        continue;
      }

      previewText.textContent = texts[i - 1];
      previewText.style.display = 'block';

      const slotData = getSlotData(i - 1);
      if (slotData && slotData.textStyle) {
        applyTextStyle(previewText, slotData.textStyle);
      }
    }

    elements.previewOverlay.style.display = 'flex';
    setTimeout(function() {
      elements.previewOverlay.classList.add('active');
    }, 10);
  }

  function closePreview() {
    if (!elements.previewOverlay) return;

    elements.previewOverlay.classList.remove('active');
    setTimeout(function() {
      elements.previewOverlay.style.display = 'none';
    }, 300);
  }

  function getCanvasPosition(canvas, textStyle) {
    const bottomPercent = parseFloat(textStyle.bottom) || 15;
    const textY = canvas.height - (canvas.height * bottomPercent / 100);

    let textX = canvas.width / 2;
    if (textStyle.left && String(textStyle.left).indexOf('%') !== -1) {
      textX = canvas.width * parseFloat(textStyle.left) / 100;
    }

    return { textX: textX, textY: textY };
  }

  function drawTextOnCanvas(ctx, canvas, text, textStyle) {
    const position = getCanvasPosition(canvas, textStyle);
    const fontSize = parseInt(textStyle.fontSize, 10) || 14;
    const scaledFontSize = Math.floor(fontSize * (canvas.width / 350));

    ctx.font = (textStyle.fontWeight || '500') + ' ' + scaledFontSize + 'px Arial, sans-serif';
    ctx.fillStyle = textStyle.color || '#808080';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(text, position.textX, position.textY);
  }

  function generatePreviewImage(texts, callback) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.crossOrigin = 'anonymous';

    const imageSrc = elements.productImage ? elements.productImage.src : '';

    if (!imageSrc) {
      callback(null);
      return;
    }

    img.onload = function() {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      for (let i = 0; i < texts.length; i++) {
        const slotData = getSlotData(i);
        const textStyle = slotData && slotData.textStyle ? slotData.textStyle : {
          bottom: '15%',
          left: '50%',
          fontSize: '14px',
          color: '#808080',
          fontWeight: '500'
        };

        if (texts[i]) {
          drawTextOnCanvas(ctx, canvas, texts[i], textStyle);
        }
      }

      canvas.toBlob(function(blob) {
        const formData = new FormData();
        formData.append('image', blob);

        fetch('https://api.imgbb.com/1/upload?key=06e6055dd96e349bc8b46f5ebb65bc00', {
          method: 'POST',
          body: formData
        })
        .then(function(response) { return response.json(); })
        .then(function(data) {
          if (data.success) {
            callback(data.data.url);
          } else {
            callback(null);
          }
        })
        .catch(function() {
          callback(null);
        });
      }, 'image/png', 0.8);
    };

    img.onerror = function() {
      callback(null);
    };

    img.src = imageSrc;
  }

  function getCartPropertyKey(slotIndex, slotCount) {
    if (slotCount === 1) {
      return 'Personalization';
    }
    return 'Personalization ' + (slotIndex + 1);
  }

  function addToCart(variantId, withPersonalization, texts, previewImageUrl) {
    if (!variantId) {
      alert('Please select a variant');
      return;
    }

    const quantityInput = document.querySelector('[data-product-quantity]');
    const quantity = quantityInput ? Math.max(1, parseInt(quantityInput.value, 10) || 1) : 1;
    const slotCount = texts.length;
    const properties = {
      engraving_required: withPersonalization && texts.some(function(t) { return t.trim(); }) ? 'true' : 'false',
      image_url: document.getElementById('variantImageUrl') ? document.getElementById('variantImageUrl').value : ''
    };

    if (withPersonalization) {
      for (let i = 0; i < texts.length; i++) {
        if (texts[i].trim()) {
          properties[getCartPropertyKey(i, slotCount)] = texts[i].trim();
        }
      }

      properties['Engraving Value'] = texts
        .map(function(t) { return t.trim(); })
        .filter(Boolean)
        .join(' | ');
    }

    if (previewImageUrl) {
      properties.image_url = previewImageUrl;
    }

    if (window.RabitatCart && window.RabitatCart.setProductAddButtonLoading) {
      window.RabitatCart.setProductAddButtonLoading(true);
    }

    var addPayload = {
      id: variantId,
      quantity: quantity,
      properties: properties
    };

    if (window.RabitatCart && typeof window.RabitatCart.withCartSections === 'function') {
      addPayload = window.RabitatCart.withCartSections(addPayload);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(addPayload)
    })
    .then(function(response) { return response.json(); })
    .then(function(lineItem) {
      if (window.RabitatCart && typeof window.RabitatCart.finishAddToCart === 'function') {
        window.RabitatCart.finishAddToCart(lineItem);
      } else if (window.RabitatCart && typeof window.RabitatCart.syncCartAfterAdd === 'function') {
        if (window.RabitatCart.setProductAddButtonLoading) {
          window.RabitatCart.setProductAddButtonLoading(false);
        }
        window.RabitatCart.syncCartAfterAdd(lineItem);
      } else {
        fetch('/cart.js').then(function(response) { return response.json(); }).then(function(cart) {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(
            new CustomEvent('rabitat:cart:updated', {
              detail: { item_count: cart.item_count, cart: cart }
            })
          );
        });
      }

      if (window.injectGoKwikPreviews) {
        setTimeout(function() {
          window.injectGoKwikPreviews();
        }, 1000);
      }
    })
    .catch(function(error) {
      console.error('Error adding to cart:', error);
      alert('Error adding to cart. Please try again.');
    })
    .finally(function() {
      if (window.RabitatCart && window.RabitatCart.setProductAddButtonLoading) {
        window.RabitatCart.setProductAddButtonLoading(false);
      }
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        const cartCountElements = document.querySelectorAll('[data-cart-count], .cart-count, .cart__count');
        cartCountElements.forEach(function(el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function(error) { console.error('Error updating cart count:', error); });
  }

  window.PersonalizationModal = {
    open: openModal,
    close: closeModal,
    openPreview: openPreview,
    closePreview: closePreview,
    getCurrentVariant: function() { return currentVariantId; },
    getPersonalizationText: function() { return selectedPersonalizationTexts.join(' | '); },
    getPersonalizationTexts: function() { return selectedPersonalizationTexts.slice(); },
    isEnabled: function() { return isPersonalizationEnabled; }
  };

  init();

})();
